import React from 'react';

const Loader = ({ fullScreen = false, text = 'Loading...', size = 'md' }) => {
    const sizeMap = {
        sm: { spinner: '24px', font: '13px' },
        md: { spinner: '40px', font: '15px' },
        lg: { spinner: '60px', font: '18px' },
    };

    const currentSize = sizeMap[size] || sizeMap.md;

    const content = (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
            <div
                style={{
                    width: currentSize.spinner,
                    height: currentSize.spinner,
                    border: '3px solid rgba(99, 102, 241, 0.2)',
                    borderTop: '3px solid #6366f1',
                    borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite',
                }}
            />
            {text && (
                <span style={{ color: '#9ca3af', fontSize: currentSize.font, fontWeight: '500' }}>
                    {text}
                </span>
            )}
        </div>
    );

    if (fullScreen) {
        return (
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                    backgroundColor: 'rgba(17, 24, 39, 0.85)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {content}
            </div>
        );
    }

    return (
        <div style={{ padding: '32px 0', width: '100%', display: 'flex', justifyContent: 'center' }}>
            {content}
        </div>
    );
};

export default Loader;
